import React, { useEffect, useState, useMemo } from 'react'
import CommonCard from '../../../../global/card'
import CommonTable from '../../../../global/table'
import { useGenericQuery } from '../../../../../queries/use-generic-query';
import { QUERY_KEYS } from '../../../../../lib/query-constants';
import { formatNumber, getCurrentYear, getMonthName } from '../../../../../utils/functions';
import CommonSkeletonLoader from '../../../../global/loading'

const EnhancedPaymentMonthWise = () => {
    const [allyears, setAllYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(() => getCurrentYear());

    const { data: reportData, isLoading } = useGenericQuery({
        endpoint: "/admin/payment-monthwise",
        queryKey: QUERY_KEYS.paymentMonthWise.lists({ q: selectedYear }),
        queryParams: { q: selectedYear }
    })

    useEffect(() => {
        const startYear = 2021;
        const endYear = new Date().getFullYear();
        const years = Array.from({ length: endYear - startYear + 1 }, (v, k) => startYear + k).reverse();

        const yearOptions = years.map((year) => ({ value: year, label: year.toString() }));

        setAllYears(yearOptions);
    }, []);

    const tableData = useMemo(() => {
        if (isLoading || !reportData) return [];

        const months = Array.from({ length: 12 }, (_, i) => i + 1);
        let totalAnnualIncome = 0;

        const monthlyData = months.map((month) => {
            const reportForMonth = reportData.find((data) => data._id.month === month);
            const amount = reportForMonth ? reportForMonth.totalAmount : 0;
            totalAnnualIncome += amount;

            return {
                key: month,
                month: getMonthName(month),
                amount: amount,
            };
        });

        // Append Total Row
        monthlyData.push({
            key: 'total',
            month: 'Total',
            amount: totalAnnualIncome,
            isTotal: true
        });

        return monthlyData;
    }, [reportData, isLoading]);

    const columns = [
        {
            title: "Month",
            dataIndex: "month",
            key: "month",
            render: (text, record) => record.isTotal ? <strong>{text}</strong> : text
        },
        {
            title: "Income",
            dataIndex: "amount",
            key: "amount",
            render: (text, record) => {
                const formatted = `$ ${formatNumber(text)}`;
                return record.isTotal ? <strong>{formatted}</strong> : text > 0 ? formatted : "-";
            }
        }
    ];

    return (
        <CommonCard
            isFilters={{
                show: true,
                data: [
                    {
                        name: "filterByYear",
                        value: selectedYear,
                        placeholder: "Filter by year",
                        options: allyears,
                        onChange: setSelectedYear,
                        className: "w-72"
                    }
                ]
            }}
            isLoading={{
                show: isLoading,
                loaderCmp: <CommonSkeletonLoader type='table' />
            }}
        >
            <CommonTable
                columns={columns}
                data={tableData}
                pagination={false} // Monthwise usually doesn't need pagination for 13 rows
            />
        </CommonCard>
    )
}

export default EnhancedPaymentMonthWise